import React, { Component } from 'react'
import { muiWithStyles, MuiGrid, MuiClear, MuiToolTip, MuiEdit, MuiTypography, MuiPopover } from '../../../ui/MaterialUIComponents';
import theme from '../../../../assests/theme'
import lodashUtil from 'lodash';
import unavailable from '../../../../assests/images/unavailable.png';
import AlertDialogComponent from './AlertDialogComponent';
import { gradePickerUtil } from '../../gradePicker';
import { TeacherUnavailabilityComponent, TeacherAssignedSubjectComponent } from '.'
const useStyles = () => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
  },
});
export class TeacherCardComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      anchorEl: null,
      open: null,
      openDialog: false
    }
  }

  handlePopoverOpen = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      open: event.currentTarget
    })
  };
  handlePopoverClose = () => {
    this.setState({
      anchorEl: null,
      open: null
    })
  };
  // state = {
  //   openDialog: false
  // }
  getSubjectString = (assignedSubjects) => {
    let displaySubjects = []
    if (assignedSubjects != undefined && assignedSubjects.length > 0) {
      let subject = {};
      if (assignedSubjects.length === 1) {
        subject.subjectName = assignedSubjects[0].subjectName;
        subject.toolTip = '';
        subject.grades = gradePickerUtil.getGradesString(assignedSubjects[0].gradeDetails);
        subject.role = assignedSubjects[0].isMainTeacher ? "Main Teacher" : "TA";
        subject.preffered = assignedSubjects[0].isFixedTeacher ? "Preferred" : "";
        displaySubjects.push(subject)
      } else if (assignedSubjects.length === 2) {
        subject.subjectName = assignedSubjects[0].subjectName;
        subject.toolTip = ''
        subject.role = assignedSubjects[0].isMainTeacher ? "Main Teacher" : "TA";
        subject.preffered = assignedSubjects[0].isFixedTeacher ? "Preferred" : "";
        subject.grades = gradePickerUtil.getGradesString(assignedSubjects[0].gradeDetails);
        displaySubjects.push(subject)
        subject = {}
        subject.subjectName = assignedSubjects[1].subjectName;
        subject.toolTip = ''
        subject.role = assignedSubjects[1].isMainTeacher ? "Main Teacher" : "TA";
        subject.preffered = assignedSubjects[1].isFixedTeacher ? "Preferred" : "";
        subject.grades = gradePickerUtil.getGradesString(assignedSubjects[1].gradeDetails);
        displaySubjects.push(subject)

        subject = {}
        subject.subjectName = "";
        subject.role = "";
        subject.preffered = "";
        subject.grades = [];
        displaySubjects.push(subject)
      } else {
        subject.subjectName = assignedSubjects[0].subjectName;
        subject.grades = gradePickerUtil.getGradesString(assignedSubjects[0].gradeDetails);
        subject.toolTip = ''
        subject.role = assignedSubjects[0].isMainTeacher ? "Main Teacher" : "TA";
        subject.preffered = assignedSubjects[0].isFixedTeacher ? "Preferred" : "";
        displaySubjects.push(subject)

        subject = {}
        subject.subjectName = assignedSubjects[1].subjectName;
        subject.grades = gradePickerUtil.getGradesString(assignedSubjects[1].gradeDetails);
        subject.toolTip = ''
        subject.role = assignedSubjects[1].isMainTeacher ? "Main Teacher" : "TA";
        subject.preffered = assignedSubjects[1].isFixedTeacher ? "Preferred" : "";
        displaySubjects.push(subject)

        subject = {}
        subject.subjectName = assignedSubjects.length - 2 + "+" + " More Subjects";
        subject.role = '';
        subject.preffered = '';
        subject.toolTip = ''
        subject.grades = []
        displaySubjects.push(subject)
      }
    }
    return displaySubjects;
  }
  handleClickOpenDialog = () => {
    this.setState({ openDialog: true });
  }

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  }

  handleClickOnYes = () => {
    this.setState({ openDialog: false });
    this.props.onClickOfDelete(this.props.teacher);
  }
  getClassTeacherString = (teacher) => {
    let classTeacherString;
    if (teacher.classTeacher.isClassTeacher) {
      let level = teacher.classTeacher.gradeLevel ? teacher.classTeacher.gradeLevel : "";
      let grade = teacher.classTeacher.gradeName ? teacher.classTeacher.gradeName : "";
      let group = teacher.classTeacher.groupName ? teacher.classTeacher.groupName : "";
      if (level === "") {
        return "["+this.props.i18n.teachers.groupTeacher+"]"
      } else {
        return "[" + this.props.i18n.teachers.groupTeacherFor +" " + level + " " + grade + " " + group + "]"
      }

    } else {
      return ""
    }
  }
  render() {
    const classes = useStyles();
    if (!lodashUtil.isEmpty(this.props.teacher)) {
      return (
        <MuiGrid id='grid' xs={12} direction="row" style={{ background: theme.palette.grey.lightest, border: '1px solid' + theme.palette.grey.dark }}>
          <MuiGrid container style={{ padding: 5 }}>
            <MuiGrid container xs={12} direction="row" justify="flex-end">
              <MuiGrid item xs align='left'><MuiTypography variant="caption" style={{ color: theme.palette.grey.dark }} gutterBottom component="h2">{this.props.teacher.teacherId}</MuiTypography></MuiGrid>

              {!this.props.teacher.weeklyAvailability.availableForAllHours ? <MuiGrid item xs={1}>
                <TeacherUnavailabilityComponent teacher={this.props.teacher} />
              </MuiGrid> : null}

              <MuiGrid item xs={1}>
                <MuiEdit id='edit' onClick={() => this.props.editTeacher(this.props.teacher)} style={{ color: theme.palette.grey.dark }} />
              </MuiGrid>
              <MuiGrid item xs={1}>
                <MuiClear id='cancel' style={{ color: theme.palette.grey.dark, cursor: 'pointer' }} onClick={() => this.handleClickOpenDialog()} />
              </MuiGrid>
            </MuiGrid>
            {this.state.openDialog ?
              <AlertDialogComponent
                {...this.props}
                openDialog={this.state.openDialog}
                handleCloseDialog={this.handleCloseDialog}
                deleteTeacher={this.props.deleteTeacher}
                handleClickOnYes={this.handleClickOnYes}
                errorMessage = {this.props.i18n.teachers.confirmDelete}
              /> : null}

            <MuiGrid container xs={12} >
              <MuiGrid container xs={12} >
                <MuiGrid item xs={12} align='left'><MuiTypography variant="h5" gutterBottom component="h2">{this.props.teacher.firstName + " " + this.props.teacher.lastName}</MuiTypography></MuiGrid>
              </MuiGrid>
              <MuiGrid container xs={12} >
                <MuiGrid item xs={12} align='left'><MuiTypography variant="body2" gutterBottom component="h2">{this.props.teacher.maxTeachingHours + " periods maximum " + this.getClassTeacherString(this.props.teacher)}</MuiTypography></MuiGrid>
              </MuiGrid>
              <MuiGrid container xs={12} justify="space-between" >
                {this.getSubjectString(this.props.teacher.assignedSubjects).map((subject, index) =>
                  <MuiGrid container xs={12}>
                    {index < 2 ?
                      <MuiGrid item xs={4}>
                        <MuiTypography variant="body2" align='left' gutterBottom>{subject.subjectName}</MuiTypography>
                      </MuiGrid>

                      :
                      <MuiGrid align='left'>
                        <MuiToolTip title={subject.toolTip} arrow placement="right">
                          {/* <MuiTypography variant="body2" gutterBottom>{subject.subjectName}</MuiTypography> */}
                          <TeacherAssignedSubjectComponent subjectName={subject.subjectName} assignedSubjects={this.props.teacher.assignedSubjects} />
                        </MuiToolTip>
                      </MuiGrid>
                    }
                    <MuiGrid item  xs>
                      <MuiTypography variant="body2" align='left' gutterBottom>{subject.grades}</MuiTypography>
                    </MuiGrid>
                    <MuiGrid item xs={4} >
                      <MuiTypography variant="body2" align='left' gutterBottom>{subject.preffered + " " + subject.role}</MuiTypography>
                    </MuiGrid>
                  </MuiGrid>)}

              </MuiGrid></MuiGrid>

          </MuiGrid></MuiGrid>
      )
    } else {
      return null;
    }
  }
}

export default muiWithStyles(useStyles)(TeacherCardComponent)


